import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentScenarioId } from '@/context';

export const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const scenarioId = getCurrentScenarioId();
    navigate(`/i/${scenarioId}`, { viewTransition: true });
  }, [navigate]);

  return null;
};
